var _rect, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 410,
    height: 105,
    rx: 22,
    fill: "white",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 10v28c0 22 14 37 35 37s35-15 35-37V10",
    fill: "none",
    stroke: "#0872d7",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 10,
    r: 7,
    fill: "#f6a623"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 10,
    r: 7,
    fill: "#f6a623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 75c0 11 8 20 20 20 10 0 18-6 20-15",
    fill: "none",
    stroke: "#0872d7",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 73,
    r: 9,
    fill: "white",
    stroke: "#0872d7",
    strokeWidth: 6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 47,
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#0b55ae"
  }, "\n    Y KHOA\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 72,
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0872d7"
  }, "\n    cuahangykhoa.com\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aa3fb416eac03b151827ed41024c89c1.svg";
export { ForwardRef as ReactComponent };